// ----------------------------- Debounce

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.

function debounce( func, wait, immediate ) {
    let timeout;
    return function () {
        let context = this, args = arguments;
        let later = function () {
            timeout = null;
            if ( !immediate ) func.apply( context, args );
        };
        let callNow = immediate && !timeout;
        clearTimeout( timeout );
        timeout = setTimeout( later, wait );
        if ( callNow ) func.apply( context, args );
    };
}

/**
 * Make the elements that match the class the same min-height.
 *
 * @param {string} elementClass
 */
function makeEqualHeight(elementClass) {
    let items = document.querySelectorAll(elementClass);
    let highestValue = 0;

    for (let i = 0; i < items.length; i++) {
        const itemHeight = items[i].clientHeight;

        highestValue = itemHeight > highestValue ? itemHeight : highestValue;
    }

    for (let i = 0; i < items.length; i++) {
        items[i].style.minHeight = `${highestValue}px`;
    }
}

/**
 * Remove min-height from the elements that match the class.
 *
 * @param {string} elementClass
 */
function clearEqualHeight(elementClass) {
    let items = document.querySelectorAll(elementClass);

    for (let i = 0; i < items.length; i++) {
        items[i].style.minHeight = 0;
    }
}

/**
 * Make elements the same height.
 */
export function equalHeightInit() {
    let windowWidth = window.innerWidth,
        break1 = 768,
        break2 = 992,
        break3 = 1200;

    if ( windowWidth < break1 ) { clearEqualHeight('.card__content'); } else { makeEqualHeight('.card__content'); }
    if ( windowWidth < break2 ) { clearEqualHeight('.card__content h3:first-child'); } else { makeEqualHeight('.card__content h3:first-child'); }
    if ( windowWidth < break1 ) { clearEqualHeight('.card__footer'); } else { makeEqualHeight('.card__footer'); }
    if ( windowWidth < break2 ) { clearEqualHeight('.grid-block__inner .column-title'); } else { makeEqualHeight('.grid-block__inner .column-title'); }
    if ( windowWidth < break2 ) { clearEqualHeight('.grid-block__inner p'); } else { makeEqualHeight('.grid-block__inner p'); }
    if ( windowWidth < break1 ) { clearEqualHeight('.value-pack-card__body'); } else { makeEqualHeight('.value-pack-card__body'); }
    if ( windowWidth < break1 ) { clearEqualHeight('.blog-post-card__body'); } else { makeEqualHeight('.blog-post-card__body'); }
    if ( windowWidth < break1 ) { clearEqualHeight('.js-call-out-card__holder--is-frontpage-promo .call-out-card__body-text'); } else { makeEqualHeight('.js-call-out-card__holder--is-frontpage-promo .call-out-card__body-text'); }
    if ( windowWidth < break2 ) { clearEqualHeight('.service-card__body'); } else { makeEqualHeight('.service-card__body' ); }
    if ( windowWidth < break1 ) { clearEqualHeight('.comparison-table__package-title'); } else { makeEqualHeight('.comparison-table__package-title'); }
    if ( windowWidth < break2 ) { clearEqualHeight('.tab-service-item--text-holder'); } else { makeEqualHeight('.tab-service-item--text-holder'); }
}

/**
 * Typekit functions for fonts loading
 */
export function initTypeKit() {
    try {
        Typekit.load({
            loading: function () {
                // execute when fonts start loading
            },
            active: function () {
                // execute when fonts become active
            },
            inactive: function () {
                // execute when fonts become inactive
            }
        });
    } catch (e) {}

}

/**
 * Srcset BG
 */
export function srcsetBG() {
    let bgs = document.querySelectorAll('.srcset-bg');

    let updateBgImage = debounce(function() {
        if( bgs ) {
            for ( let i = 0; i < bgs.length; i++ ) {
                let bg = bgs[ i ],
                    srcsetImage = bg.querySelector( '.srcset-bg-src' );
                if ( srcsetImage ) {
                    let src = typeof(srcsetImage.currentSrc) !== 'undefined' ? srcsetImage.currentSrc : srcsetImage.src;
                    bg.style.backgroundImage = 'url("' + src + '")';
                }
            }
        }
    }, 250);

    window.addEventListener( 'load', updateBgImage);
    window.addEventListener( 'resize', updateBgImage);
}



// WEBPACK FOOTER //
// ./src/js/utils.js